<mat-tab-group
  [selectedIndex]="selectedIndex"
  [attr.aria-label]="ariaLabel() || null"
  (selectedIndexChange)="onIndexChange($event)"
>
  @for (tab of tabs(); track tab.id) {
    <mat-tab [label]="tab.label" [disabled]="!!tab.disabled" />
  }
</mat-tab-group>
